var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShiftDriverGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.999,
    height: 69.999,
    viewBox: "0 0 69.999 69.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(-21 -19.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 69.999,
    height: 69.999,
    rx: 5,
    transform: "translate(21 19.999)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_group_24px",
    d: "M29.977,16.591a5.8,5.8,0,1,0-5.8-5.8A5.771,5.771,0,0,0,29.977,16.591Zm-15.454,0a5.8,5.8,0,1,0-5.8-5.8A5.771,5.771,0,0,0,14.522,16.591Zm0,3.864C10.021,20.454,1,22.714,1,27.215V35H28.045V27.215C28.045,22.714,19.023,20.454,14.522,20.454Zm15.454,0c-.56,0-1.2.039-1.874.1a8.152,8.152,0,0,1,3.806,6.665V35H43.5V27.215C43.5,22.714,34.478,20.454,29.977,20.454Z",
    transform: "translate(33.751 34.999)",
    fill: "#25556e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftDriverGroup);
export default __webpack_public_path__ + "static/media/shift_driver_group.07685d04f9813e93cb0dee6c3f595dd3.svg";
export { ForwardRef as ReactComponent };